import { flex } from '@/styles/mixins';
import styled from 'styled-components';

export const TableLayoutWrap = styled.div`
	${flex('column')};
  	flex: 1;
	overflow: hidden;
	/* padding-right: 20px; */
	width: 100%;
	height: 100%;

	.input--wrap {
		padding: 10px 0;
		width: 100%;
		${flex('row', 'space-between')};
		& .ant-input-group-wrapper {
			width: 200px;
		}
	}
	.input-sub{
		width: 100%;
		${flex('row', 'space-between')};
	}

	.table--wrap {
		width: 100%;
		flex: 1;
		overflow: hidden;

		.spliter-warp{
			width: 100%;
			height: 100%;

			& .ant-splitter-panel {
				overflow-x: hidden;
				overflow-y: hidden;
			}

			& .ant-splitter-panel--wrap {
				padding-right: 16px;
				position: relative;
			}

			& .ant-modal-wrap {
				position: static;
			}

			& .ant-modal {
				width: 100% !important;
			}

			& .ant-modal-header{
				display: none;
			}

			& .ant-modal-content{
				box-sizing: border-box;
				margin-left: 16px;
				padding: 0 16px 0 16px;
				box-shadow: none;
				border: 1px solid #F3F3F3;
			}
		}
	}
`;
